import { render, staticRenderFns } from "./campo-vertical.vue?vue&type=template&id=53d00b04&scoped=true&"
import script from "./campo-vertical.vue?vue&type=script&lang=ts&"
export * from "./campo-vertical.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d00b04",
  null
  
)

export default component.exports